import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mockup-modal" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { class: "input locating-input bg-white" }
const _hoisted_6 = { class: "flag" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "pl-075" }, " 10 101 0101 ", -1)
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_12 = { class: "text-dark" }
const _hoisted_13 = {
  class: "input bg-white p-075",
  style: {"border-radius":".5rem"}
}
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "button btn block bg-primary btn" }

import { get_geo, user_geo } from '@/utils/geo'
import { countries, Country } from '@/utils/countries'
import { ref } from 'vue'
import { strings } from '../../strings'


export default /*#__PURE__*/_defineComponent({
  __name: 'mockup-modal',
  setup(__props) {

const country = ref<Country|undefined>()

if (user_geo) {
  country.value = countries[user_geo]
} else {
  const iso2 = get_geo() ?? 'ES'
  country.value = countries[iso2]
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(strings).core['PhoneError']), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: `/img/flags/${country.value!.code.toLowerCase()}.svg`
          }, null, 8, _hoisted_7),
          _createElementVNode("span", null, _toDisplayString(country.value!.dial_code), 1)
        ]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(strings).core.MessageLb), 1)
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(strings).core.TextMsgDefault), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(strings).core['Start']), 1)
    ])
  ]))
}
}

})